{
  "zoomControl": {
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière",
    "resetZoom": "Zoom initial"
  },
  "roleTesting": {
    "title": "Test de rôle",
    "testingAsLabel": "Tester comme",
    "exitButton": "Quitter le test de rôle",
    "close": "Fermer",
    "tooltipFormat": "Test en tant que {{role}} - Cliquez pour changer"
  },
  "languageSwitcher": {
    "title": "Langue",
    "selectLabel": "Langue",
    "close": "Fermer",
    "tooltip": "{{language}} - Cliquer pour modifier",
    "exitButton": "Sortir"
  },
  "support": {
    "contactSupport": "Contacter le support",
    "dialogTitle": "Demande d'assistance",
    "tutorialVideos": "Vidéos tutorielles",
    "questionLabel": "Question",
    "questionPlaceholder": "Décrivez votre demande ici...",
    "cancelButton": "Annuler",
    "sendButton": "Envoi",
    "successMessage": "Merci ! Votre demande d'assistance a bien été reçue. Nous vous contacterons dans les plus brefs délais."
  },
  "selectTailNumber": {
    "tailNumberLabel": "N° immat.",
    "notInRegistryShort": "Pas encore dans le registre.",
    "notInRegistryLong": "Cet aéronef n'est pas encore dans notre registre.",
    "requestButton": "Demande",
    "requestDialogTitle": "Soumettre une demande d'aéronef",
    "requestDialogDescription": "Vérifiez les informations ci-dessous et cliquez sur « Envoyer la demande » pour ajouter cet aéronef à notre registre.",
    "tailNumberFieldLabel": "Immatriculation",
    "fboLabel": "FBO",
    "requestedByLabel": "Demandé par",
    "cancelButton": "Annuler",
    "submitRequestButton": "Envoyer la demande",
    "submitting": "Envoi en cours...",
    "requestErrorMessage": "Impossible d'envoyer la demande. Veuillez réessayer.",
    "waitForCredentials": "Veuillez patienter pendant la vérification de vos identifiants",
    "confirmationTitle": "✈️ Demande d'appareil envoyée !",
    "confirmationMessage": "Nous avons bien reçu votre demande pour l'appareil <strong>{{tailNumber}}</strong>. Notre équipe l'examinera et l'ajoutera prochainement au registre. Vous serez notifié dès qu'il sera disponible.",
    "gotItButton": "Compris !"
  },
  "splitButton": {
    "ariaLabel": "bouton partagé",
    "selectStrategyAriaLabel": "stratégie de fusion"
  },
  "speedDialNav": {
    "label": "Libellé",
    "simplifyDemo": "Simplifier la démo",
    "demo": "Démo",
    "userManagement": "Gestion utilisateurs"
  },
  "windDisplay": {
    "loading": "Chargement...",
    "noData": "--"
  },
  "dateRangeControl": {
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "next7Days": "7 prochains j.",
    "thisWeek": "Cette semaine",
    "next30Days": "30 prochains jours",
    "next60Days": "Prochains 60 jours"
  },
  "favorites": {
    "nameLabel": "Nom",
    "saveButton": "Enregistrer",
    "overwriteConfirm": "Un favori nommé « {{name}} » existe déjà. Voulez-vous le remplacer ?",
    "overwriteButton": "Oui, remplacer"
  },
  "assignTripButton": {
    "assigned": "Attribué",
    "assign": "Attribuer",
    "assignTo": "Attribuer à {{locationName}}",
    "assignedTo": "Affecté à {{locationName}}",
    "assignSelected": "Attribuer {{count}} vols sélectionnés",
    "assignCount": "Attribuer ({{count}})",
    "thisHangar": "Ce hangar",
    "thisRamp": "Ce tarmac",
    "successMessage": "Affecté {{tailNumber}} à {{locationName}}",
    "bulkSuccessMessage": "Affecté {{count}} vols à {{locationName}}",
    "errorMessage": "Échec de l'attribution du vol"
  },
  "layoutToolbar": {
    "tooltips": {
      "measuringTool": "Outil de mesure"
    },
    "buttons": {
      "clear": "Effacer",
      "dump": "Vider",
      "print": "Impr.",
      "copy": "Copier",
      "share": "Partager",
      "allTenants": "Tous locataires"
    },
    "confirmations": {
      "pleaseConfirm": "Veuillez confirmer",
      "clearMultiHangar": "Cela supprimera tous les aéronefs répertoriés dans les hangars sélectionnés.",
      "clearNuclear": "☢️ OPTION NUCLÉAIRE : Cette action retirera TOUS les aéronefs de ce/cette {{locationType}} depuis maintenant jusqu'à la fin de leurs vols. Cette action est difficilement réversible. Êtes-vous sûr ?",
      "clearLocation": "Cela supprimera tous les aéronefs répertoriés dans ce {{locationType}}.",
      "clearNuclearOk": "Oui, effacer tous les vols (NUCLÉAIRE)",
      "clearLocationOk": "Oui, supprimer tous les aéronefs",
      "dumpMultiHangar": "Cette action retirera tous les aéronefs des hangars sélectionnés.",
      "dumpScheduled": "Cela supprimera tous les aéronefs de ce {{locationType}} pour toute la durée de leur vol.",
      "dumpLocation": "Cela déplacera tous les aéronefs vers l'avant.",
      "dumpHangarsOk": "Oui, vider les hangars",
      "dumpScheduledOk": "Oui, retirer de {{locationType}}",
      "dumpLocationOk": "Oui, supprimer le hangar",
      "resetMultiHangar": "Réinitialise les hangars sélectionnés selon la disposition commune à tous les locataires.",
      "resetLocation": "Cela réinitialisera la disposition {{locationType}} pour tous les locataires.",
      "resetOk": "Réinitialiser",
      "printHangarsTitle": "Imprimer hangars",
      "printHangarsCaption": "Sélectionnez les hangars que vous souhaitez imprimer.",
      "copyHangarsTitle": "Copier les hangars",
      "copyHangarsCaption": "Sélectionnez les hangars que vous souhaitez copier."
    },
    "messages": {
      "copiedToClipboard": "Copié dans le presse-papiers",
      "urlCopiedToClipboard": "URL copiée dans le presse-papiers"
    },
    "errors": {
      "failedToCopyUrl": "Échec de la copie de l'URL",
      "failedToCopyImage": "Impossible de copier l'image dans le presse-papiers. L'image est peut-être trop volumineuse ou il y a un problème avec les images d'arrière-plan.",
      "copyFailedDetailed": "La copie a échoué pour {{locationType}} « {{locationName}} ». Taille du canvas : {{canvasWidth}}x{{canvasHeight}}. Consultez la console du navigateur pour les logs détaillés.",
      "copyFailedGeneric": "Échec de la copie de {{locationType}} dans le presse-papiers. L'image est peut-être trop volumineuse pour la mémoire de votre appareil ou un problème est survenu lors du rendu de l'aéronef. Veuillez réessayer ou consulter la console pour plus de détails.",
      "multiHangarCopyFailedDetailed": "La copie multi-hangar a échoué. Taille du canevas : {{canvasWidth}}x{{canvasHeight}}. Hangars sélectionnés : {{hangarCount}}. Consultez la console du navigateur pour les logs détaillés.",
      "multiHangarCopyFailedGeneric": "Échec de la copie de la disposition multi-hangar dans le presse-papiers. L'image est peut-être trop volumineuse pour la mémoire de votre appareil ou un problème est survenu lors du rendu des aéronefs. {{hangarCount}} hangars sélectionnés. Essayez de sélectionner moins de hangars ou consultez la console pour plus de détails."
    },
    "dialogs": {
      "featureNotSupported": {
        "title": "Fonctionnalité non disponible",
        "message": "Cette fonctionnalité n'est pas prise en charge sur Firefox. Pour l'utiliser, veuillez utiliser un autre navigateur.",
        "okButton": "OK"
      },
      "copyFailed": {
        "title": "Copie échouée",
        "okButton": "OK"
      }
    }
  },
  "favoritesButton": {
    "buttons": {
      "favorites": "Favoris"
    },
    "dialogs": {
      "saveFavoriteTitle": "Enregistrer la pile favorite",
      "favoritesTitle": "Favoris",
      "pleaseConfirm": "Veuillez confirmer"
    },
    "emptyState": {
      "imageAlt": "Aucun favori",
      "message": "Aucun favori enregistré. Cliquez sur l'icône « Enregistrer » pour commencer à sauvegarder vos piles favorites."
    },
    "multiHangarFavorites": {
      "buttons": {
        "use": "Util",
        "delete": "Supprimer"
      },
      "confirmations": {
        "useText": "Retirer tous les aéronefs des hangars sélectionnés et les remplacer par les aéronefs de « {{stackName}} ».",
        "useNote": "Remarque : Les aéronefs de cette pile enregistrée seront déplacés d'autres hangars si nécessaire.",
        "useOk": "Réinitialiser",
        "deleteText": "Vous êtes sur le point de supprimer « {{stackName}} » de tous les hangars sélectionnés.",
        "deleteNote": "C'est-à-dire que si \"{{stackName}}\" est enregistré pour les hangars A, B, C… mais que je n'ai sélectionné que A et B… alors C conserve toujours son \"{{stackName}}\" enregistré",
        "deleteOk": "Oui, supprimer ce favori"
      },
      "stackColumn": "Pile",
      "searchPlaceholder": "Rechercher une pile",
      "noStack": "Aucune pile"
    },
    "singleFavorite": {
      "printSubtitle": "Favori : {{name}}",
      "searchPlaceholder": "Rechercher une pile",
      "buttons": {
        "use": "Voir",
        "delete": "Supprimer",
        "print": "Impr."
      },
      "confirmations": {
        "title": "Veuillez confirmer",
        "useText": "Retirer tous les aéronefs de votre {{locationType}} actuel et les remplacer par ceux de « {{name}} ».",
        "useOk": "Oui, revenir à cette pile enregistrée",
        "deleteText": "Vous êtes sur le point de supprimer {{name}}.",
        "deleteOk": "Oui, supprimer ce favori"
      }
    }
  },
  "multiLocationSave": {
    "labels": {
      "name": "Nom"
    },
    "buttons": {
      "cancel": "Annuler",
      "save": "Enregistrer"
    },
    "confirmations": {
      "overwriteMessage": "Un favori nommé « {{name}} » existe déjà. Voulez-vous le remplacer ?",
      "overwriteOk": "Oui, remplacer"
    }
  },
  "addMovableObstacle": {
    "buttonText": "Ajouter un obstacle mobile",
    "dialogTitle": "Ajouter un obstacle mobile",
    "cancelButton": "Annuler",
    "doneButton": "Fait",
    "movableObstacleGrid": {
      "columns": {
        "name": "Nom",
        "lengthFt": "Longueur (ft)",
        "widthFt": "Largeur (pi)",
        "heightFt": "Hauteur (ft)"
      },
      "notAvailable": "S/O",
      "addButton": "Ajouter",
      "searchPlaceholder": "Rechercher un type d'obstacle par nom",
      "messages": {
        "addSuccess": "{{obstacleName}} ajouté à {{locationName}}",
        "addError": "Échec de l'ajout de {{obstacleName}} : {{errorMessage}}"
      }
    }
  },
  "addFBO": {
    "buttonLabel": "+ FBO",
    "dialogTitle": "Ajouter un FBO",
    "instructions": "Créer un nouveau FBO et inviter le premier utilisateur.",
    "successMessage": "Un e-mail a été envoyé à <b style=\"color: #3c6ce9\">{{email}}</b> avec une invitation pour <b style=\"color: #3c6ce9\">{{name}}</b>. Vous pouvez également utiliser le lien ci-dessous.",
    "nameLabel": "Nom",
    "emailLabel": "Adresse e-mail",
    "okButton": "OK",
    "cancelButton": "Annuler",
    "addButton": "Ajouter"
  },
  "buttonMoveTo": {
    "assignTo": "Attribuer à",
    "moveTo": "Déplacer",
    "unassigned": "Non attribué"
  },
  "buttonNotes": {
    "buttonText": "Notes"
  },
  "editTenant": {
    "dialogTitle": "Modifier l'aéronef",
    "selectAircraftLabel": "Sélectionner un aéronef",
    "duplicateTailWarning": "Immatriculation en double",
    "ownerManagerLabel": "Propriétaire/Gérant",
    "notesLabel": "Notes",
    "notesPlaceholder": "Ajouter des notes sur cet aéronef...",
    "lastUpdate": "Dernière mise à jour : {{time}} ({{date}}) par {{user}}",
    "typeLabel": "Type",
    "tenantOption": "Locataire",
    "transientOption": "Passage",
    "yellowCardLabel": "Carton jaune (YC)",
    "unassignedText": "Non attribué",
    "naText": "S/O",
    "notHangaredText": "Non hangaré",
    "confirmTitle": "Veuillez confirmer",
    "transientConfirmText": "Transformer ce locataire permanent en visiteur signifie que cet aéronef ne sera plus basé dans vos hangars. Il restera dans votre liste d'aéronefs visiteurs.",
    "transient": "Passage",
    "base": "Base",
    "cancelButton": "Annuler",
    "saveButton": "Enregistrer",
    "insufficientPermissionTitle": "Autorisation insuffisante",
    "insufficientPermissionText": "Permissions insuffisantes pour modifier un locataire de base. Vous avez actuellement le rôle <u>{{roleName}}</u>. Vous devez être <u>FBO Admin</u> ou <u>Manager</u> pour modifier un locataire de base. Veuillez contacter votre administrateur AirPlx si vous pensez qu'il s'agit d'une erreur."
  },
  "aircraftSpecsTooltip": {
    "heightLabel": "H : {{height}}"
  },
  "fboMenu": {
    "switchFBO": "Changer de FBO",
    "noFBOTitle": "Aucun FBO trouvé",
    "noFBOMessage": "Vous n'appartenez actuellement à aucun FBO. Veuillez contacter votre administrateur système pour en rejoindre un.",
    "okButton": "OK"
  },
  "buttonUploadImage": {
    "compressingMessage": "Compression de l'image. Cela prendra quelques secondes."
  },
  "selectDumpTo": {
    "label": "À :",
    "holdingArea": "Zone d'attente",
    "frontOfHangar": "Devant le hangar"
  },
  "locationTextField": {
    "unassigned": "Non attribué",
    "ramp": "Tarmac",
    "hangar": "Hangar",
    "assignedLabel": "Affecté à {{locationType}}",
    "currentLabel": "Actuel {{locationType}}"
  },
  "aircraftListItem": {
    "tenant": "Locataire",
    "transient": "Passage",
    "yc": "YC",
    "noseIn": "Nez entré",
    "tailIn": "Arrivée",
    "front": "Avant",
    "back": "Retour",
    "okOutside": "OK dehors",
    "locked": "Verrouillé"
  },
  "timelineAircraftList": {
    "title": "Chronologie",
    "aircraftCount": "{{count}} aéronef",
    "filterPlaceholder": "Filtrer...",
    "searchPlaceholder": "Rechercher l'immatriculation dans tous les vols...",
    "countOfTotal": "{{filtered}} sur {{total}}",
    "totalAndHere": "{{total}} au total • {{here}} ici",
    "filteredAndHere": "{{filtered}} sur {{total}} • {{filteredHere}} ici",
    "noAircraftFound": "Aucun aéronef trouvé avec l'immatriculation « {{tailNumber}} »",
    "createNewTrip": "Créer un nouveau vol"
  },
  "multiHangarSelect": {
    "selectAll": "Tout sélect.",
    "cancel": "Annuler",
    "ok": "OK"
  },
  "timelineAircraftListItem": {
    "cancelled": "ANNULÉ",
    "here": "ICI",
    "hereNow": "SUR PLACE",
    "unassigned": "Non attribué",
    "unassignedStatus": "NON ATTRIBUÉ",
    "atLocation": "À {{locationName}}",
    "arrivesInHours": "ARRIVE DANS {{hours}}H",
    "arrivesInDays": "ARRIVE DANS {{days}}J",
    "unknownAircraft": "Aéronef inconnu"
  },
  "aircraftPreferencesMenu": {
    "tailIn": "Arrivée",
    "noseIn": "Nez entré",
    "frontRow": "Rang avant",
    "backRow": "Rang arrière",
    "okOutside": "OK extérieur",
    "locked": "Verrouillé",
    "incrementalPark": "Stationnement incrémental",
    "editAircraft": "Modifier l'aéronef",
    "removeAircraft": "Retirer l'aéronef",
    "removeObstacle": "Supprimer l'obstacle",
    "confirmRemove": "Oui, retirer cet aéronef",
    "confirmTitle": "Veuillez confirmer",
    "confirmTextReference": "Transformer ce locataire en transit signifie que cet aéronef ne sera plus basé dans vos hangars. Il restera dans votre liste d'aéronefs en transit.",
    "confirmTextRemove": "Cet aéronef sera retiré de ce {{locationType}}.",
    "hangar": "hangar",
    "ramp": "tarmac"
  },
  "aircraftActionMenu": {
    "noActiveTripWarning": "Aucun vol actif ou à venir trouvé pour cet appareil",
    "tripDetailsNotFound": "Détails du vol introuvables",
    "assignedForEntireTrip": "{{tailNumber}} affecté à {{locationName}} pour l'ensemble du vol",
    "failedAssignEntireTrip": "Échec de l'attribution du vol complet",
    "assigned": "{{tailNumber}} affecté à {{locationName}}",
    "failedAssignAircraft": "Échec de l'attribution de l'appareil",
    "jumpTo": "Aller à...",
    "assignHere": "Assigner ici",
    "assignHereEntireTrip": "Assigner ici (vol complet)",
    "failedLoadTrips": "Échec du chargement des vols pour cet appareil",
    "viewTrips": "Voir vols",
    "hereAt": "— Ici à {{locationName}} —",
    "hoursStay": "{{hours}}h d'escale",
    "otherLocations": "— Autres emplacements —",
    "andMoreAt": "...et {{count}} autre(s) à {{locationName}}",
    "todayAt": "Aujourd'hui à {{time}}",
    "tomorrowAt": "Demain à {{time}}",
    "yesterdayAt": "Hier à {{time}}",
    "inDaysAt": "Dans {{days}} jours à {{time}}"
  },
  "bulkActionToolbar": {
    "tripsSelected": "{{count}} vol sélectionné",
    "selectLocation": "Sélectionner un emplacement...",
    "assign": "Attribuer",
    "unassign": "Retirer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "clear": "Effacer"
  },
  "scheduledAircraftContextMenu": {
    "confirmTitle": "Veuillez confirmer",
    "confirmRemoveText": "Cela supprimera l'aéronef du planning à cet horaire.",
    "confirmRemoveButton": "Oui, retirer du planning",
    "missingDataError": "Données requises manquantes pour le changement de lieu",
    "conflictError": "Un autre aéronef occupe déjà cet emplacement à cette heure",
    "gapError": "Impossible de créer des trous dans le planning",
    "updateLocationError": "Échec de modification du lieu",
    "loadTripsError": "Échec du chargement des vols pour cet appareil",
    "viewTrips": "Voir vols",
    "unlock": "🔓 Débloquer",
    "lock": "🔒 Verrou",
    "tailIn": "Arrivée",
    "noseIn": "Nez entré",
    "frontRow": "Rang avant",
    "backRow": "Rang arrière",
    "okOutside": "OK Extérieur",
    "locked": "Verrouillé",
    "moveTo": "Déplacer",
    "editAircraft": "Modifier l'aéronef",
    "removeAircraft": "Retirer l'aéronef",
    "unassigned": "Non attribué"
  },
  "addTenantButton": {
    "tooltipAddTrip": "Ajouter vol",
    "tooltipAddAircraft": "Ajouter un aéronef",
    "buttonAddTrip": "Ajouter vol",
    "buttonAddAircraft": "Ajouter un aéronef",
    "dialogTitleAddTrip": "Ajouter vol",
    "dialogTitleAddAircraft": "Ajouter un aéronef",
    "tabs": {
      "newAircraft": "Nouvel aéronef",
      "priorTransients": "Transits précédents",
      "tenants": "Locataires",
      "bulkAdd": "Ajout groupé",
      "addTrip": "Ajouter vol",
      "allTrips": "Tous les vols",
      "bulkUpload": "Import en masse",
      "addMovableObstacle": "Ajouter un obstacle mobile"
    },
    "buttons": {
      "cancel": "Annuler",
      "add": "Ajouter",
      "createTrip": "Créer un vol",
      "creating": "Création...",
      "saveTrips": "Enregistrer",
      "saving": "Enregistr…",
      "done": "Fait"
    },
    "notifications": {
      "addedToLocation": "{{model}} ajouté à {{locationName}}",
      "added": "{{model}} ajouté",
      "tryAutostack": "Essayez AutoStack pour voir votre nouvel aéronef en action !",
      "runAutostack": "Lancer AutoStack"
    },
    "confirmTitle": "Veuillez confirmer",
    "confirmHangar": "Nous attribuerons ce nouveau locataire de base à ce hangar. Si vous devez modifier les attributions de hangar par défaut, vous pouvez le faire en modifiant cet aéronef spécifique.",
    "confirmRamp": "Nous assignerons ce nouveau locataire Tie-Down à ce tarmac. Si vous devez modifier les affectations par défaut du tarmac, vous pouvez le faire en modifiant cet aéronef spécifique."
  },
  "viewSettings": {
    "buttonText": "Voir les paramètres",
    "locationNotAvailable": "Localisation non disponible",
    "tugUpdatedSuccess": "Tracteur mis à jour pour {{locationName}}",
    "tugUpdateError": "Mise à jour tracteur échouée",
    "tailNumberTooltip": "Afficher l'immatriculation sur l'aéronef",
    "tailNumberLabel": "N° immat.",
    "notesTooltip": "Pour voir une note unique ou toutes les notes, allez dans Paramètres > Configuration",
    "notesLabel": "Notes",
    "modelTooltip": "Afficher le modèle d'aéronef sur l'aéronef",
    "modelLabel": "Modèle",
    "footprintTooltip": "Afficher l'envergure et la longueur de l'aéronef sélectionné",
    "footprintLabel": "Gabarit",
    "sopSpacingTooltip": "Espacement horizontal (contour)",
    "sopSpacingLabel": "Espacement SOP",
    "wallSpacingTooltip": "Espacement des zones de remplissage",
    "wallSpacingLabel": "Remplissage mural",
    "bayBoundariesTooltip": "Afficher les limites de travée des hangars à auvent gradins",
    "bayBoundariesLabel": "Limites de baie",
    "overlapsTooltip": "Met en évidence tous les chevauchements, n'évalue pas la sécurité de l'espacement vertical",
    "overlapsLabel": "Conflits",
    "coPilotTooltip": "Sélectionnez un aéronef non empilé et obtenez des options conformes aux SOP",
    "coPilotLabel": "Copilote",
    "tugLabel": "Trac",
    "useFBODefault": "Utiliser la valeur FBO par défaut ({{defaultTugName}})",
    "spotsTooltip": "Afficher les places sur le tarmac",
    "spotsLabel": "Places",
    "rampImageTooltip": "Superposer l'image satellite du tarmac",
    "rampImageLabel": "Image du tarmac",
    "zoneHeatmapTooltip": "Afficher l'occupation des zones ({{hours}} h à venir)",
    "zoneHeatmapLabel": "Carte thermique",
    "hours24": "24 h",
    "hours72": "72 h",
    "week1": "1s",
    "none": "Aucun"
  },
  "currentAircraft": {
    "title": "Aéronef actuel"
  },
  "layout": {
    "permissionDenied": {
      "modifyLayout": "Vous n'avez pas la permission de modifier la mise en page"
    },
    "deleteConfirmation": {
      "confirmAircraft": "Confirmer l'aéronef",
      "confirmObstacle": "Confirmer l'obstacle",
      "removeAircraft": "Retirer l'aéronef",
      "removeObstacle": "Supprimer l'obstacle",
      "removeTransient": "Supprimer le passager",
      "title": "Confirmation de suppression"
    }
  }
}
